import { DictionaryEntry, TreeListEntry, TreeListNode } from '@sdbn/common';
import { MasterDetailListEntry } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';
import { Description, Price, PriceContainer, RetailPrice } from '../erp-common/erp-common.model';


export class CatalogColumnDefinitions {

  // Datenstruktur wird exklusiv im Client genutzt.
  definitions = new Map<string, string[]>();

  constructor(d: any) {
    if (d.definitions != null) {
      for (const k of Object.keys(d.definitions)) {
        this.definitions.set(k, d.definitions[k]);
      }
    }
  }
}

export class Catalog implements MasterDetailListEntry {


    id: number;
    articleSearch = false;
    title = '';
    name = new DictionaryEntry();
    //nodes = new Array<CatalogNode>();

    constructor(catalog: any) {
        this.id = catalog.id;
        this.articleSearch = catalog.articleSearch != null && catalog.articleSearch === true;
        this.name = new DictionaryEntry(catalog.name);
        // if (catalog.nodes != null) {
        //     for (const node of catalog.nodes) {
        //         this.nodes.push(new CatalogNode(node));
        //     }
        // }
    }
    public get childs(): MasterDetailListEntry[] {
      return null;
    }
    public get groupIdentifier(): string {
      return null;
    }

    public calculateTitle(language: string) {
      const nameValue = this.name.getValue(language);
      this.title = nameValue != null ? nameValue.value : null;
    }

    public get listTitle(): string {
        return this.title;
    }

    public get listTitleDictionaryKey(): string {
        return null;
    }

    public get listSubTitle(): string {
      return null;
    }
}

export class CatalogDetails extends Catalog {
  nodes = new Array<CatalogNode>();

  constructor(data: any) {
    super(data);
    if (data.nodes != null) {
      for (const node of data.nodes) {
        this.nodes.push(new CatalogNode(node));
      }
    }
  }
}

export class CatalogTableGroupHeader {
  level: number;
  name: DictionaryEntry;
  catalogNode: CatalogNode;

  constructor(header: any) {
    this.level = header?.level;
    this.name = header?.name;
    this.catalogNode = header?.catalogNode;
  }
}

export class CatalogNode implements TreeListNode {

    id: number;

    name = new DictionaryEntry();

    nodes = new Array<CatalogNode>();
    articleEntries = new Array<ArticleEntry>();

    constructor(node: any) {
        this.id = node.id;
        this.name = new DictionaryEntry(node.name);
        if (node.nodes != null) {
            for (const childNode of node.nodes) {
                this.nodes.push(new CatalogNode(childNode));
            }
        }
        if (node.articleEntries != null) {
            for (const entry of node.articleEntries) {
                this.articleEntries.push(new ArticleEntry(entry));
            }
        }
    }

    public get childs(): Array<TreeListNode> {
      return this.nodes;
    }

    public get entries(): Array<TreeListEntry> {
        return this.articleEntries;
    }

}

export class ArticleEntry {

    id: number;
    name: DictionaryEntry;
    articleId: number;
    articleTypeId: number;
    articleIdentifier: string;
    retailPriceDaily: Price;
    // Datenstruktur wird exklusiv im Client genutzt.
    valuesMap = new Map<string, string>();
    // Schnittstellenobject zum Server
    values: any = {};

    constructor(entry: any) {
        this.id = entry.id;
        if (entry.name != null && entry.name.length > 0) {
            this.name = new DictionaryEntry(entry.name[0].title);
        }
        if (entry.values != null) {
          for (const k of Object.keys(entry.values)) {
            this.values[k] = entry.values[k];
            this.valuesMap.set(k, entry.values[k]);
          }
        }
        this.articleId = entry.articleId;
        this.articleTypeId = entry.articleTypeId;
        this.articleIdentifier = entry.articleIdentifier;
        this.retailPriceDaily = entry.retailPriceDaily;
    }

    public getValueByAttributeId(attributeId: number): string {
      return this.valuesMap.get(attributeId + '');
    }
}

export class Article {

    id: number;
    articleTypeId: number;
    archived = false;
    identifier: string;

    retailPricesFromBasicArticle = false;
    priceContainer = new PriceContainer({});
    descriptions = new Array<Description>();
    // Datenstruktur wird exklusiv im Client genutzt.
    valuesMap = new Map<string, string>();
    // Schnittstellenobject zum Server
    values: any = {};

    constructor(article: any) {

        console.log('article is', article);

        this.id = article.id;
        this.articleTypeId = article.articleTypeId;
        this.identifier = article.identifier;
        this.retailPricesFromBasicArticle = article.retailPricesFromBasicArticle === true;
        this.archived = article.archived != null ? article.archived : false;

        if (article.priceContainer != null) {
            this.priceContainer = new PriceContainer(article.priceContainer);

        }

        if (article.descriptions != null) {
            for (let item of article.descriptions) {
                console.log('description is', item);
                this.descriptions.push(new Description(item));
            }
        }

        if (article.values != null) {
          for (const k of Object.keys(article.values)) {
            this.values[k] = article.values[k];
            this.valuesMap.set(k, article.values[k]);
          }
        }
    }

    public getValueByAttributeId(attributeId: number): string {
      return this.valuesMap.get(attributeId + '');
    }

    /**
     * Befüllt das Attribut 'values' der Serverschnittstelle basierend auf der im Client
     * verwendeten Map 'valuesMap'.
     */
    public fillValuesFromValuesMap() {
      this.values = {};
      this.valuesMap.forEach((val: string, key: string) => {
        this.values[key] = val;
      });
    }

}

export class SaveArticleResponse extends ServiceResponse {
  articleId: number;
}

export class AddCatalog {

    name: DictionaryEntry;

    constructor(addCatalog: any) {
        this.name = new DictionaryEntry(addCatalog.name);
    }

}

export class ChangeCatalog {

  catalogId: number;
  name: DictionaryEntry;

  constructor(changeCatalog: any) {
      this.catalogId = changeCatalog.catalogId;
      this.name = new DictionaryEntry(changeCatalog.name);
  }

}

export class AddCatalogNode {

    parentNodeId: number;
    catalogId: number;

    name: DictionaryEntry;

    constructor(addCatalogNode: any) {
        this.parentNodeId = addCatalogNode.parentNodeId;
        this.catalogId = addCatalogNode.catalogId;
        this.name = new DictionaryEntry(addCatalogNode.name);
    }

}

export class ChangeCatalogNode {

  nodeId: number;
  catalogId: number;

  name: DictionaryEntry;

  constructor(addCatalogNode: any) {
      this.nodeId = addCatalogNode.nodeId;
      this.catalogId = addCatalogNode.catalogId;
      this.name = new DictionaryEntry(addCatalogNode.name);
  }

}

export class AddArticleEntry {

    nodeId: number;
    articleId: number;

    constructor(addArticleEntry: any) {
        this.nodeId = addArticleEntry.nodeId;
        this.articleId = addArticleEntry.articleId;
    }
}

export class BasicArticle {

  id: number;

  priceContainer = new PriceContainer({});


  constructor(article: any) {
      this.id = article.id;
      if (article.priceContainer != null) {
          this.priceContainer = new PriceContainer(article.priceContainer);
      }
  }

}

export class BasicArticleRetailPrices {

  priceContainer = new PriceContainer({});

  constructor(basicArticleRetailPrices: any) {
    if (basicArticleRetailPrices.priceContainer != null) {
      this.priceContainer = new PriceContainer(basicArticleRetailPrices.priceContainer);
  }
  }

  public findValidRetailPrice(referenceDate: Date): RetailPrice {
    for (const currentRetailPrice of this.priceContainer.retailPrices) {
      if (currentRetailPrice.validPeriod.from.getTime() <= referenceDate.getTime()
          && currentRetailPrice.validPeriod.until.getTime() >= referenceDate.getTime()) {
        return currentRetailPrice;
      }
    }
    return null;
  }
}

export class CostsPriceSources {

  sources = new Array<string>();

  constructor(costsPriceSources: any) {
    if (costsPriceSources != null && costsPriceSources.sources != null) {
      for (const source of costsPriceSources.sources) {
        this.sources.push(source);
      }
    }
  }

}

export class CostsPriceImportResult {
  articlesWithNotModifiableCostsPrices = new Array<string>();
}
